/**
 * Organisations API Mutations
 *
 * Create and delete operations.
 */

// API client
import { apiClient } from '../client';

// Types
import type { CreateOrganisationPayload, UpdateOrganisationPayload, ApiOrganisation, OrganisationShowResponse } from './types';

// Create (GRAIN-2237): wraps the payload under the `organisation` key to match
// the controller's create_params. 422s carry field-level errors in
// ApiError.fieldErrors (see ../client.ts).
export async function createOrganisation(payload: CreateOrganisationPayload): Promise<ApiOrganisation> {
  const response = await apiClient.post<OrganisationShowResponse>('/api/organisations', {
    organisation: payload,
  });
  return response.data.organisation;
}

export async function updateOrganisation(id: number, payload: UpdateOrganisationPayload): Promise<ApiOrganisation> {
  const { data } = await apiClient.patch<OrganisationShowResponse>(`/api/organisations/${id}`, {
    organisation: payload,
  });
  return data.organisation;
}

// Soft-deletes an organisation (Discard gem, server-side). Idempotent: the
// endpoint returns 204 even for an unknown or already-discarded id, so a
// re-delete resolves rather than throwing.
export async function deleteOrganisation(id: number): Promise<void> {
  await apiClient.delete<void>(`/api/organisations/${id}`);
}
